<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1"><a id="pl-6-5"></a><b>Straight Strips</b></p>
<p class="h2" id="pt1">SIDEWALK CHALK</p>
<p class="fig"><img src="images/6_1.jpg"/></p>
<div class="bck">
<p class="side1"><b>Finished Block:</b> 16˝ × 16˝</p>
<p class="side2"><b>2½˝ × strips:</b> 2 white, 4 print</p>
<p class="side2"><b>White fabric:</b> 1 strip 6½˝ × WOF</p>
<p class="side2"><b>Solid fabric:</b> 1 strip 6½˝ × WOF (Makes 3 blocks.)</p>
</div>
<p class="noindentt"><i>The cutting method that creates blocks from tubes of fabric is the nifty secret that makes this quilt come together with ease. It’s a study of complexity born of simplicity.</i></p>
<p class="noindentt"><i>All seams are ¼˝.</i></p>
<p class="noindentt"><span class="col1"><b>1.</b></span> Sew a 2½˝ print strip on either side of a 2½˝ white strip lengthwise to make a strip set. <b>1A</b></p>
<p class="fig"><img src="images/6_2.jpg"/></p>
<p class="noindentt">Repeat to make a second strip set.</p>
<p class="noindentt"><span class="col1"><b>2.</b></span> Pair a strip set with each of the 6½˝ wide strips and sew together along both long edges to make a tube. Repeat with the other pair. <b>2A and 2B</b></p>
<p class="fig"><img src="images/6_3.jpg"/></p>
<p class="noindentt"><span class="col1"><b>3.</b></span> Use a ruler with a 45° guideline that has sides at least 9½˝ long. Line up the 45° line to the seam at the top. Make the first cut. Toss the scrap. <b>3A</b></p>
<p class="fig"><img src="images/6_5.jpg"/></p>
<p class="noindentt">Slide the ruler down to the bottom line of stitching, moving along the cut edge of fabric. Make the second cut when the ruler’s 45° guideline sits on the stitching. <b>3B</b></p>
<p class="fig"><img src="images/6_4.jpg"/></p>
<p class="noindentt">Now return to the top line of stitching, moving the ruler along the newly cut edge. Continue in this fashion with both strip tubes. Each strip will yield 6 half-square triangles.</p>
<p class="noindentt">Square each half-square triangle to 8½˝ × 8½˝.</p>
<p class="noindentt"><span class="col1"><b>4.</b></span> Arrange 2 of each type of half-square triangle as shown. <b>4A</b></p>
<p class="fig"><img src="images/6_6.jpg"/></p>
<p class="noindentt">Sew the half-square triangles in rows first then sew the 2 rows together to form a block, nesting seams. Make a total of 3 blocks.</p>
<p class="h3"><a id="pl-7-6"></a><i>Sidewalk Chalk Quilt</i></p>
<p class="fig"><img src="images/7_1.jpg"/></p>
<p class="noindentt">Glow by Amy Butler for Rowan Bella Solids Breeze &amp; Bella Solids White by Moda Fabrics</p>
<p class="fig"><img src="images/7_2.jpg"/></p>
<div class="bck">
<p class="side1a"><b>Finished Quilt:</b> 89˝ × 105˝</p>
</div>
<p class="cap_h">MATERIALS</p>
<p class="noindentt">QUILT TOP: 1 roll of 2½˝ print strips</p>
<p class="noindentt">3½ yards of background fabric</p>
<p class="noindentt">2 yards of solid complementary fabric</p>
<p class="noindentt">BORDER: 1½ yards</p>
<p class="noindentt">BINDING: ¾ yard</p>
<p class="noindentt">BACKING: 9½ yards-vertical seam(s) or 3¼ yards 108˝ wide</p>
<p class="cap_h">CONSTRUCTION NOTES</p>
<p class="noindentt">This quilt uses 30 blocks cut from 20 strip set tubes (10 white and 10 with complementary fabric). Borders are cut 5˝ wide.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0005_part-title-1.vue?ee4e769e